import {Component, ElementRef, forwardRef, Host, Injector, Input, OnInit, Optional, Renderer2, SkipSelf, ViewChild} from '@angular/core';
import {ControlContainer, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ValueAccessorAbstract} from '@wba-ui-module/components/formfields/commons/value-accessor.abstract';
import {EventUtils} from '@wba/utils/event.utils';
import {FormUtils} from '@wba/utils/form.utils';
import DOMPurify from 'dompurify';

@Component({
    selector: 'wba-input-textarea',
    templateUrl: './textarea.component.html',
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextareaComponent),
            multi: true
        }],
    standalone: false
})
export class TextareaComponent extends ValueAccessorAbstract implements ControlValueAccessor, OnInit {

  @Input() id: string;
  @Input() name: string;
  @Input() label: string;
  @Input() placeholder = '';
  @Input() ariaLabel: string;
  @Input() maxLength = 3000;
  @Input() controlName: string;
  @Input() required = false;
  @Input() rows = 4;
  @Input() cols = 50;
  @ViewChild('textarea') el: ElementRef;

  constructor(@Optional() @Host() @SkipSelf() private readonly controlContainer: ControlContainer,
              private readonly eventUtils: EventUtils,
              private readonly elementRef: ElementRef,
              private readonly renderer: Renderer2,
              protected injector: Injector) {
    super(injector);
  }

  get value(): string {
    if (this.control.value !== '') {
      this.innerValue = this.control.value;
    }
    return this.innerValue;
  }

  writeValue(value: string) {
    if (value !== this.innerValue) {
      this.control.setValue(value);
      this.innerValue = value;
    }
  }
  // set accessor including call the onchange callback
  set value(v: string) {
    if (v !== this.innerValue) {
      this.innerValue = v.replaceAll(/<[^>]*>/g, '');
      this.control.setValue(this.innerValue);
      this.onChangeCallback(this.innerValue);
    }
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.controlContainer) {
      if (this.controlName) {
        this.control = this.controlContainer.control.get(this.controlName) as FormControl;
      }
      if (!this.formControlName && this.controlName) {
        this.formControlName = this.controlName;
      }
    }
  }

  // Set touched on blur
  onBlur() {
    if (this.value && this.value.length > 0) {
      const sanitized = DOMPurify.sanitize(this.value, {
        ALLOWED_TAGS: [],
        ALLOWED_ATTR: []
      });
      this.value = FormUtils.formValueSingleWhitespaces(sanitized);
    }

    this.onTouchedCallback();
    this.eventUtils.focusOut$.next(this.elementRef);
  }
}
